import { Box, Grow, Slide } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { localStorageItemKeys } from '~constants/local-storage-items'
import { ToggleButton } from '../toggle-button'
import { ToggleContent } from './toggle-content'

export const useMock =
  localStorage.getItem(localStorageItemKeys.retainedPostLogout.useMockData) ===
  'true'

export function MswToggle() {
  const [isOpen, setIsOpen] = useState(false)
  const [isMocking, setIsMocking] = useState(false)

  useEffect(() => {
    setIsMocking(useMock)
  }, [])

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = event.target.checked
    localStorage.setItem(
      localStorageItemKeys.retainedPostLogout.useMockData,
      isChecked ? 'true' : 'false',
    )
    setIsMocking(isChecked)
    window.location.reload()
  }

  if (!import.meta.env.DEV) return null

  return (
    <Box
      sx={{
        position: 'fixed',
        zIndex: 1202,
        bottom: '158px',
        right: '72px',
      }}
    >
      <ToggleButton isMocking={isMocking} onClick={() => setIsOpen(!isOpen)} />
      {isOpen && (
        <Slide in direction="up">
          <ToggleContent
            isMocking={isMocking}
            handleChange={handleChange}
            onClose={() => setIsOpen(!isOpen)}
          />
        </Slide>
      )}
    </Box>
  )
}
